// extracted by mini-css-extract-plugin
module.exports = {"header":"MobileScreen_header___7JbP","footer":"MobileScreen_footer__JO5_Q"};